import moment from 'moment';
import React, { Component } from 'react'
import { Grid, Container, Segment, Dropdown, Popup, Icon, Table, Loader, Dimmer } from 'semantic-ui-react';
import './UsersWeeklyFillRateContainer.less';
import { getUsersWeeklyFillRate } from 'services/Manager';



const initialStates = {
    userFillRateData: [],
    users: [],
    weeks: [],
    currentLastDaysSelection: {
        value: 60,
        text: "Last 60 days"
    },
    dataRefreshingState: false,
    dataRefreshDisabledState: false,
    selectedUser: {},
    pageLoading: true
}


const lastDaysDropdownData = [
    {
        value: 30,
        text: "Last 30 days"
    },
    {
        value: 60,
        text: "Last 60 days"
    },
    {
        value: 90,
        text: "Last 90 days"
    },
    {
        value: 120,
        text: "Last 120 days"
    }
]
class UsersWeeklyFillRateContainer extends Component {


    constructor(props) {
        super(props);
        this.state = initialStates;
    }

    componentDidMount = () => {
        this.loadData();
    }


    loadData = async () => {
        this.setState({ pageLoading: true })
        let res = await getUsersWeeklyFillRate(this.state.currentLastDaysSelection.value);
        if (res.resStatus == 200) {
            this.setState({
                userFillRateData: res.data.weeklyFillRateData,
                users: res.data.users,
                weeks: res.data.weeks,
                pageLoading: false,
                dataRefreshingState: false, 
                dataRefreshDisabledState: false 
            })
        }
    }

    onLastDaysChange = (e, data) => {
        this.setState({ currentLastDaysSelection: _.first(_.filter(lastDaysDropdownData, item => item.value == data.value)) },
            () => {
                this.loadData();
            })
    }

    refreshData = () => {
        this.setState({ dataRefreshingState: true, dataRefreshDisabledState: true })
        setTimeout(() => {
            this.loadData();
        }, 1000);
    }

    getUserFillRate = (user, week) => {
        let fillRateData = this.state.userFillRateData;
        let fillRateObject = fillRateData.find((fillrate) => {
            return fillrate.weekYear == week.weekYear && fillrate.userID == user.userID
        })

        if (fillRateObject) {
            return parseFloat(fillRateObject.fill_rate).toFixed(2) + ` (TR: ${fillRateObject.total_request}, TA: ${fillRateObject.total_accepted})`
        } else {
            return "N/A"
        }
    }

    getWeekTotal = (week) => {
        let fillRateData = this.state.userFillRateData;
        let weekData = fillRateData.filter((data) => {
            return data.weekYear == week.weekYear
        })
        let totalRequests = 0;
        let totalAccepted = 0;
        weekData.forEach((week) => {
            totalRequests = totalRequests + parseInt(week.total_request)
            totalAccepted = totalAccepted + parseInt(week.total_accepted)
        })
        return parseFloat((totalAccepted / totalRequests) * 100).toFixed(2) + ` (TR: ${totalRequests}, TA: ${totalAccepted})`
    }

    render() {
        return (
            <Container key={"user-weekly-fill-rate-container-key"} fluid className={"user-weekly-fill-rate-dashboard-container"}>
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header mobile-header-new">
                            <div className="main-heading main-heading-new">
                                Weekly Fill Rate
                            </div>
                        </div>
                        <Segment key={"filters-segment-key"}>
                            <Grid key={"filter-grid-key"}>
                                <Grid.Row className={"fill-rates-filters-row"} key={"ill-rates-filters-row-key"}>
                                    <Grid.Column width={4} className={"fill-rate-col"}>
                                        <Dropdown fluid name="lastDays" key="act-sub-fil-lastdays"
                                            selection
                                            options={lastDaysDropdownData}
                                            value={this.state.currentLastDaysSelection.value}
                                            text={this.state.currentLastDaysSelection.text}
                                            onChange={this.onLastDaysChange}
                                        ></Dropdown>
                                    </Grid.Column>
                                    <Grid.Column textAlign={"right"} width={1} >
                                        <Popup position={"bottom center"} content='Refresh' trigger={<Icon
                                            onClick={() => { this.refreshData() }}
                                            loading={this.state.dataRefreshingState}
                                            size="large"
                                            disabled={this.state.dataRefreshDisabledState}
                                            circular
                                            //size='small' 
                                            //inverted 
                                            //color='blue' 
                                            name='refresh'
                                        />} />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                        {
                            this.state.pageLoading ? <Loader active={true} size='massive'> </Loader>
                                :
                                <Segment key={"data-segment-key"} className={`content-segment`}>
                                    <>
                                        <Container fluid>
                                            {/* <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.commissionPaymentListCount / rowsPerPage)} activePage={this.state.page} onPageChange={this.onPageChange} /> */}
                                        </Container>
                                        <Table celled striped>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Weeks</Table.HeaderCell>
                                                    {
                                                        this.state.users.map((user, userIndex) => {
                                                            return <>
                                                                <Table.HeaderCell>{user.userFirstName + " " + user.userLastName}</Table.HeaderCell>
                                                            </>
                                                        })
                                                    }
                                                    <Table.HeaderCell>Total</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {
                                                    this.state.weeks.map((week, weekIndex) => {
                                                        let weekTotal = this.getWeekTotal(week);
                                                        return <>
                                                            <Table.Row key={"week-row-" + weekIndex}>
                                                                <Table.Cell key={"week-col-" + weekIndex}>
                                                                    <div>
                                                                        {week.weekYear}
                                                                    </div>
                                                                    <div>
                                                                        {moment(week.weekStartDate).format('MMM DD') + " - " + moment(week.weekEndDate).format('MMM DD')}
                                                                    </div>
                                                                </Table.Cell>
                                                                {
                                                                    this.state.users.map((user, userIndex) => {
                                                                        return <>
                                                                            <Table.Cell key={"user-col-" + userIndex}>
                                                                                <div>
                                                                                    {this.getUserFillRate(user, week)}
                                                                                </div>
                                                                            </Table.Cell>
                                                                        </>
                                                                    })
                                                                }
                                                                <Table.Cell key={"week-total-col-" + weekIndex}>
                                                                    <div>
                                                                        {weekTotal}
                                                                    </div>
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        </>
                                                    })
                                                }
                                                {
                                                    this.state.weeks.length == 0 && <Table.Row>
                                                        <Table.Cell colspan={16}>
                                                            No record found
                                                        </Table.Cell>
                                                    </Table.Row>
                                                }
                                            </Table.Body>
                                        </Table>
                                        <Container fluid>
                                            {/* <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.commissionPaymentListCount / rowsPerPage)} activePage={this.state.page} onPageChange={this.onPageChange} /> */}
                                        </Container>
                                    </>
                                </Segment>
                        }
                    </div>
                </div>
            </Container>
        )
    }
}

export default UsersWeeklyFillRateContainer
